import Vuelidate from 'vuelidate';
import Vue from 'vue';

Vue.use(Vuelidate);
